import { AfterViewInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SidenavigationLink } from './sidenavigation.model';
import { Router } from '@angular/router';
import { sortByNumberedString } from 'utils/sort-utils';
@Component({
  selector: 'valg-sidenavigation',
  templateUrl: './sidenavigation.component.html',
  styleUrls: [ './sidenavigation.component.scss' ],
})
export class SidenavigationComponent implements AfterViewInit, OnChanges{
  @Input() links: SidenavigationLink[] = [];

  public urlPrefix?: string;

  constructor(private readonly router: Router){
    this.urlPrefix = this.getRelativeToElectionPrefix();
  }

  ngAfterViewInit(): void {
    this.autoExpandIfOne();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['links']){
      this.sortAlphabetically(this.links);
      this.autoExpandIfOne();
    }
  }
  autoExpandIfOne(){
    if(this.links.length === 1 && this.links[0].showChildren){
      this.links[0].expanded = true;
    }
  }

  sortAlphabetically(links: SidenavigationLink[]){
    links.sort((a, b) => sortByNumberedString(a.title, b.title));
    links.forEach(link => {
      if (link.showChildren && link.children) {
        this.sortAlphabetically(link.children);
      }
    });
  }

  onItemClick(link: SidenavigationLink, index: number, parent: number | null){
    let expanded = false;
    if((link.expanded === false || link.expanded === undefined) && link.showChildren){
      expanded = true;
    }
    if(link.children && link.showChildren){
      if(parent == null){
        link.expanded = expanded;
      }
    }
  }

  trackBy(index: number){
    return index;
  }

  private getRelativeToElectionPrefix(): string {
    const current = this.router.url.split('/');
    const length = current.length;

    if (length < 3) {
      return '';
    }

    return Array(length - 2).join('../');
  }

}
